import styled from '@emotion/styled';

export const ExportWrap = styled.div`
  flex-shrink: 0;
  width: auto;

  button {
    width: auto;
    min-width: 132px;
    height: 37px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 999px;
    font-weight: 600;
    white-space: nowrap;
    font-size: 13px;
  }

  @media (min-width: 769px) {
    button {
      min-width: 148px;
    }
  }
`;
